import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

type Messages = {
	modalTitle: MessageDescriptor;
	selectAvatar: MessageDescriptor;
	defaultListTitle: MessageDescriptor;
};

const messages: Messages = defineMessages({
	modalTitle: {
		id: 'project-settings-apps.avatar-modal.modal-title',
		defaultMessage: 'Choose an icon',
		description: '',
	},
	selectAvatar: {
		id: 'project-settings-apps.avatar-modal.select-avatar',
		defaultMessage: 'Select',
		description: '',
	},
	defaultListTitle: {
		id: 'project-settings-apps.avatar-modal.default-list-title',
		defaultMessage: 'Default icons',
		description: '',
	},
});
export default messages;
